import api from './api';

export async function getPacotes() {
    const response = await api.get('/pacote');
    return response.data;
}
